export default function Positioning() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#0F172A] mb-8 leading-tight">
              Built Like Infrastructure. Not Marketing.
            </h2>
            <div className="space-y-6 text-base text-gray-700 leading-relaxed">
              <p className="font-semibold text-lg text-[#0F172A]">
                Most AI agencies sell tools.
              </p>
              <p className="font-semibold text-lg text-[#0F172A]">
                Atlas builds operational architecture.
              </p>
              <p>
                We design and implement precision-driven AI systems that reinforce your core workflows — from lead intake and dispatch to compliance and client retention.
              </p>
              <p>
                Every automation connects to a measurable metric: revenue, efficiency, throughput, or margin.
              </p>
              <p className="font-semibold text-[#0F172A]">
                No guesswork. No gimmicks.
              </p>
            </div>
          </div>
          
          <div className="relative">
            <div className="w-full h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/86f239d228b247458348408db269fe0e.jpg"
                alt="AI Infrastructure Architecture"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}